import React, { useContext } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { ThemeContext } from 'styled-components';

const ButtonMenu = React.forwardRef(({
    children,
    component,
    to,
    onClick,
    dense = true,
    baseOpacity = 0.85,
    hoverOpacity = 1,
    pressedOpacity = 0.5,
    color,
    pl = 4,
    pr = 2,
    minHeight = 25,
    py = 0.3,
    ...props
}, ref) => {
    const theme = useContext(ThemeContext);

    return (
        <MenuItem
            ref={ref}
            component={component}
            to={to}
            onClick={onClick}
            dense={dense}
            {...props}
            sx={{
                opacity: baseOpacity,
                color: color,
                pl,
                pr,
                minHeight,
                py,
                backgroundColor: 'transparent !important',
                transition: 'opacity 120ms ease, background-color 0ms !important',
                '&:hover, &:active, &:focus, &.Mui-focusVisible, &.Mui-selected': {
                    transition: 'opacity 120ms ease, background-color 0ms !important',
                    backgroundColor: 'transparent !important',
                    color: `${color} !important`,
                },
                '& > *': {
                    fontWeight: 800,
                    transition: 'font-weight 120ms ease, text-shadow 120ms ease, transform 120ms ease',
                },
                '&:focus': {
                    outline: 'none',
                    backgroundColor: 'transparent !important',
                    color: `${color} !important`,
                },
                '&:focus-visible': {
                    outline: 'none',
                    backgroundColor: 'transparent !important',
                    color: `${color} !important`,
                },
                '&:hover': {
                    opacity: hoverOpacity,
                    backgroundColor: 'transparent !important',
                    color: `${color} !important`,
                    '& > *': {
                        fontWeight: 900,
                        transform: 'translate(-0.5px, -0.5px)',
                        textShadow: theme.textShadow,
                    },
                },
                '&:active': {
                    opacity: pressedOpacity,
                    transform: 'none',
                    boxShadow: 'none',
                    backgroundColor: 'transparent !important',
                    color: `${color} !important`,
                    '& > *': {
                        fontWeight: 850,
                        transform: 'none',
                        textShadow: 'none',
                    },
                },
                '&.Mui-focusVisible': {
                    backgroundColor: 'transparent !important',
                },
                '&.Mui-selected': {
                    backgroundColor: 'transparent !important',
                    color: `${color} !important`,
                },
                '&.Mui-selected:hover': {
                    backgroundColor: 'transparent !important',
                },
                '& .MuiTouchRipple-root': {
                    display: 'none !important',
                },
                '& .MuiTouchRipple-ripple': {
                    display: 'none !important',
                },
                ...props.sx,
            }}
        >
            <span style={{ display: 'inline-block' }}>{children}</span>
        </MenuItem>
    );
});

export default ButtonMenu;
